import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile text-center" }
const _hoisted_2 = { class: "text-capitalize" }
const _hoisted_3 = { class: "text mb-0" }
const _hoisted_4 = { class: "d-flex align-items-center justify-between my-4" }
const _hoisted_5 = { class: "text-center mt-5 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.completeName), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.loggedUser.emailAddress), 1),
    _createVNode(_component_localized_text, {
      localizedKey: "app_Logout",
      text: "Logout",
      class: "fs_12 brandOppositeColor fw_800 d-block mt-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
    }),
    _createVNode(_component_localized_text, {
      localizedKey: "app_Sei in gara per:",
      text: "Sei in gara per:",
      class: "text d-block mt-4 mb-2"
    }),
    _createElementVNode("h3", null, _toDisplayString(_ctx.extractionResume.stage.text), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "buttonAsInput h-auto me-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/ranking')))
      }, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.extractionResume.totalPoints), 1),
        _createVNode(_component_localized_text, {
          localizedKey: "app_Punti",
          text: "Punti",
          type: "h3",
          class: "mb-0"
        })
      ]),
      _createElementVNode("div", {
        class: "buttonAsInput h-auto ms-1",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/ranking')))
      }, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.rankingPosition), 1),
        _createVNode(_component_localized_text, {
          localizedKey: "app_Classifica",
          text: "Classifica",
          type: "h3",
          class: "mb-0"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_localized_text, {
        type: "h1",
        localizedKey: "app_Concorso terminato",
        text: "Concorso terminato"
      }),
      _createVNode(_component_localized_text, {
        localizedKey: "app_Grazie per aver partecipato",
        text: "Grazie per aver partecipato",
        class: "text d-block"
      })
    ])
  ]))
}